import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

/**
 * `<camera-number-label>` — vendor-themed camera identifier.
 *
 * Renders a panel's assigned camera number in the vendor's preferred typeface
 * and weight. Sony tends toward a heavier weight in larger displays;
 * Grass Valley toward a slightly condensed treatment. The vendor token
 * surface controls both axes without the consumer caring.
 */
@customElement('camera-number-label')
export class CameraNumberLabelElement extends LitElement {
  static override styles = [
    css`
      :host {
        display: inline-block;
        contain: layout paint;
        font-family: var(--font-data);
        color: var(--control-button-engrave);
      }
    `,
  ];

  /** Assigned camera number. Zero-padded by the rendering layer where required. */
  @property({ type: Number }) accessor camera = 0;

  override render() {
    // TODO(Phase 2): vendor-specific zero-padding rules, accent colour
    // application per the active vendor's chassis accent token.
    return html`<span>${this.camera}</span>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'camera-number-label': CameraNumberLabelElement;
  }
}
